export default "__VITE_ASSET__CGTmwVWc__"